import React from 'react';
import '../style/Home.css';

function Home() {
  return (
    <div className="home-container">
      <img src={require('../assets/profile.jpg').default} alt="profile" className="profile-picture" />
      <h1>Hi, I'm Jin!</h1>
      <p>Software Engineer | ML Engineer</p>
    </div>
  );
}

export default Home;